import { FormEvent, useState } from 'react';

import {
  ITraderWallet,
  useChangeTraderWalletStatusMutation,
  TTraderWalletStatus,
} from '@entities/trades/wallet';
import { FormItemWithError, Select } from '@shared/components/Form';
import { useModal } from '@shared/components/Modal';

interface IProps<T> {
  wallet: T;
  refetch: () => void;
}

const statusOptions: TTraderWalletStatus[] = ['closed', 'inactive', 'cooling', 'frozen'];

export const ChangeTraderWalletStatus = <T extends ITraderWallet>({
  wallet,
  refetch,
}: IProps<T>) => {
  const { id } = wallet;

  const [status, setStatus] = useState<TTraderWalletStatus | ''>('');
  const [reason, setReason] = useState('');

  const [changeTraderWalletStatus, { isLoading, isError, error, isSuccess }] =
    useChangeTraderWalletStatusMutation();

  const { closeModal } = useModal();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!status) return;

    try {
      const result = await changeTraderWalletStatus({ id, status, reason });

      if ('data' in result) {
        closeModal();
        refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <h2>Please choose new wallet status:</h2>
      <form className='popup-form' onSubmit={handleSubmit}>
        <FormItemWithError name='status' label='Status' isError={isError} error={error}>
          <Select
            name='status'
            options={statusOptions}
            getOptionLabel={s => s.charAt(0).toUpperCase() + s.slice(1)}
            getOptionValue={s => s}
            onChange={value => setStatus(value as TTraderWalletStatus)}
          >
            <option value='' disabled selected={!status}>
              Select status
            </option>
          </Select>
        </FormItemWithError>

        <FormItemWithError name='reason' label='Reason' isError={isError} error={error}>
          <input
            type='text'
            name='reason'
            id='reason'
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </FormItemWithError>

        {isSuccess && <div className='form-success'>Status changed successfully</div>}

        <div className='form-submit'>
          <button type='submit' disabled={isLoading || !status}>
            Save
          </button>
          <button type='button' className='secondary-btn' onClick={closeModal}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};
